import React, { useCallback, useState, useEffect } from "react";
import Toast from "./../LoadingError/Toast";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import { useDispatch, useSelector } from "react-redux";
// import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import MainPanel from "../main-panel/MainPanel";
import {
  productEditAction,
  productUpdateAction,
} from "../../Redux/Actions/ProductActions";
import { PRODUCT_UPDATE_RESET } from "../../Redux/Constants/ProductConstants";
import { listCategories } from "../../Redux/Actions/CategoryActions";
import { BASE_URL, PICTURE_URL } from "../../api/BaseConfig";
import axios from "axios";
import FormData from "form-data";
import { Box, Button, Checkbox, FormControl, FormLabel, Heading, Image, Input, Select } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const EditProductMain = (props) => {
  const { productId } = props;
  const DefaultLanguageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];

  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState("");
  const [categoryID, setCategoryID] = useState(null);
  const [photoUrl, setPhotoUrl] = useState([]);
  const [isFeatured, setIsFeatured] = useState(false);
  const [imageTitle, setImageTitle] = useState("");
  const [imageAlt, setImageAlt] = useState("");
  const [language, setLanguage] = useState([]);
  const dispatch = useDispatch();
  const onHandleLangChange = useCallback(
    (dataInfo) => {
      let languageList = {
        productId: parseInt(productId),
        id: parseInt(dataInfo.id),
        name: dataInfo.name,
        description: dataInfo.description,
        seoTitle: dataInfo.seoTitle,
        seoDescription: dataInfo.seoDescription,
        languageKey: dataInfo.lang,
      };
      setLanguage((ln) => [
        ...ln.filter(
          (l) =>
            l.languageKey !== dataInfo.lang &&
            l.languageKey !== "" &&
            typeof l.languageKey != "undefined"
        ),
        languageList,
      ]);
    },
    [productId]
  );

  const productEdit = useSelector((state) => state.productEdit);
  const { loading, error, product } = productEdit;

  const productUpdate = useSelector((state) => state.productUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = productUpdate;

  const categoryList = useSelector((state) => state.categoryList);
  const { categories } = categoryList;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: PRODUCT_UPDATE_RESET });
      toast.success("Product Updated", ToastObjects);
    } else {
      if (!product || product.id !== parseInt(productId)) {
        dispatch(productEditAction(productId));
      } else {
        setDiscount(product.discount);
        setCategoryID(product.categoryId);
        setLanguage(product.productRecords);
        setIsFeatured(product.isFeatured);
        setPrice(product.price);
        setImageTitle(product.imageTitle || "");
        setImageAlt(product.imageAlt || "");
        dispatch(listCategories("AZ"));
        setPhotoUrl(product.photoUrl);
      }
    }
  }, [product, dispatch, productId, successUpdate]);

  const handlePicture = async (e) => {
    const file = e.target.files[0]; 
    if (!file) return;
  
    const formData = new FormData();
    formData.append("file", file);
  
    try {
      const { data } = await axios.post(`${BASE_URL}/file`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setPhotoUrl(data);
    } catch (error) {
      toast.error("Failed to upload image", ToastObjects);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(
      productUpdateAction({
        id: parseInt(productId),
        price,
        discount,
        categoryId: parseInt(categoryID),
        photoUrl,
        imageTitle,
        imageAlt,
        productRecords: language.filter(
          (l) => l.languageKey !== "" && typeof l.languageKey != "undefined"
        ),
      })
    );
  };

  const handleChange = (event) => {
    setCategoryID(event.target.value);
  };
  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <Box className="content-header" display="flex" justifyContent="space-between">
            <Button as={Link} to="/products" colorScheme="red" variant="solid" _hover={{ bg: "red.600", color: "white" }}>
              Go to products
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Update Product
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </Box>
          <Box mt={4} p={5} borderRadius="md" boxShadow="lg">
            {errorUpdate && <Message variant="alert-danger">{errorUpdate}</Message>}
            {loadingUpdate && <Loading />}
            {loading ? (
              <Loading />
            ) : error ? (
              <Message variant="alert-danger">{error}</Message>
            ) : (
              <>
                <MainPanel
                  languageInfo={language}
                  mainLang={DefaultLanguageList}
                  changeLang={onHandleLangChange}
                />
                {categories && (
                  <FormControl mb={4}>
                    <FormLabel htmlFor="product_categories">Categories</FormLabel>
                    <Select
                      id="product_categories"
                      value={categoryID}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>Select Categories...</option>
                      {categories?.map((category) => (
                        <option value={category.id} key={category.id}>
                          {category.categoryRecords[0]?.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                )}
                <FormControl mb={4}>
                  <FormLabel htmlFor="product_price">Price</FormLabel>
                  <Input
                    type="number"
                    placeholder="Type here"
                    id="product_price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel htmlFor="product_summary">Discount</FormLabel>
                  <Input
                    type="text"
                    placeholder="Discount"
                    id="product_summary"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel htmlFor="product_featured">Is Featured?</FormLabel>
                  <Checkbox
                    id="product_featured"
                    checked={isFeatured}
                    onChange={(e) => setIsFeatured(e.target.checked)}
                  >
                    Featured
                  </Checkbox>
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel>Images</FormLabel>
                  <Input
                    type="file"
                    onChange={handlePicture}
                  />
                  <Box
                    mt={3}
                    width="300px"
                    height="250px"
                    overflow="hidden"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="lightgray" 
                  >
                    <Image
                      src={PICTURE_URL + photoUrl}
                      alt="Product"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                      }}
                      mt={2}
                    />
                  </Box>

                </FormControl>
                <FormControl mb={4}>
                  <FormLabel htmlFor="image_title">Image Title</FormLabel>
                  <Input
                    type="text"
                    id="image_title"
                    value={imageTitle}
                    onChange={(e) => setImageTitle(e.target.value)}
                    placeholder="Enter image title"
                  />
                </FormControl>
                <FormControl mb={4}>
                  <FormLabel htmlFor="image_alt">Image Alt Text</FormLabel>
                  <Input
                    type="text"
                    id="image_alt"
                    value={imageAlt}
                    onChange={(e) => setImageAlt(e.target.value)}
                    placeholder="Enter image alt text"
                  />
                </FormControl>
              </>
            )}
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditProductMain;
